
const greenSett = '#9CB227';
const grey = "#838383";
const lightGrey = "#e1e1e1";

const colors = {
    'adm': ["#DC4C68", "#D22A4B", "#AE233F", "#961E36", "#7D192D"]
};

function getColor(value, steps, key) {
    if (value === null) return lightGrey;
    const offset = steps[0] == null ? 1 : 0;
    const cols = colors[key];
    for (let i = steps.length - 1; i >= offset; i--) {
        if (value >= steps[i]) return cols[i - offset];
    }
    return cols[offset]
}

function getStyle(path, steps, propKey, layerKey) {
    if (propKey == null) {
        return styles["delete"];
    } else {
        const prop = path.feature.properties;
        const color = getColor(prop[propKey], steps, layerKey);
        const style = styles[layerKey];
        style.fillColor = color;
        return style;   
    }
}

const pointStyles = {
};

const styles = {
    "adm": {
        "color": grey,
        "weight": 1,
        "opacity": 1,
        "fill" : true,
        "fillOpacity" : 0.8,
    },

    "settContour" : {
        "color": greenSett,
        "weight": 2,
        "opacity": 0.6,
        "fill" : true,
        "fillOpacity" : 0.3
    },

    "countryMask" : {
        "color": grey,
        "weight": 2,
        "opacity": 1,
        "fill" : true,
        "fillOpacity" : 0.3
    },

    "delete": {
        "weight": 0,
        "opacity": 0,
        "fill": false,
    }

}

const onEachFeat = {
}

export {styles, pointStyles, onEachFeat, colors, lightGrey, getStyle};